import { DangerAlert } from "components/common/Alerts";
import { Breadcrumb, BreadcrumbLink } from "components/common/Breadcrumb";
import DataTable from "components/common/DataTable";
import DataTableApiResponse from "interfaces/DataTableApiResponse";
import QuoteSummary from "interfaces/QuoteSummary";
import * as moment from "moment";
import * as React from "react";
import { RouteComponentProps } from "react-router";
import { Link } from "react-router-dom";
import apifetch from "utils/apifetch";
import extractErrorMessage from "utils/extractErrorMessage";
import ContentLoading from "components/common/ContentLoading";

interface State {
    data: QuoteSummary[];
    spinner: boolean;
    errorMessage?: string;
}

export default class Index extends React.Component<
    RouteComponentProps<{}>,
    State
> {
    private baseUrl: string;
    private dataTableRef: React.RefObject<HTMLTableElement>;
    private dataTableComponentRef: React.RefObject<DataTable>;
    private quoteStatusNames: string[];

    constructor(props: RouteComponentProps<{}>) {
        super(props);

        this.state = {
            data: [],
            spinner: true,
            errorMessage: undefined,
        };

        this.baseUrl = document
            .getElementsByTagName("base")[0]
            .getAttribute("href")!;
        this.dataTableRef = React.createRef();
        this.dataTableComponentRef = React.createRef();

        this.quoteStatusNames = [
            "Not Set",
            "Pending",
            "Low App Bidder",
            "Re-Quote Pend",
            CQS ? "Caterina Award" : "Brent Award",
            "Partial Award",
            CQS ? "Caterina Lost Project" : "Brent Lost Project",
            "Did Not Get Project",
            "Cancelled",
            "Void",
            "Closed",
        ];

        this.dataTableData = this.dataTableData.bind(this);
        this.dataTableDataFilter = this.dataTableDataFilter.bind(this);
        this.setStatus = this.setStatus.bind(this);
        this.handleDataTableDraw = this.handleDataTableDraw.bind(this);
    }

    public render() {
        return (
            <div className="container">
                <div className="animated fadeIn">
                    <Breadcrumb>
                        <BreadcrumbLink to="/">Home</BreadcrumbLink>
                        <BreadcrumbLink isActive={true}>Quotes</BreadcrumbLink>
                    </Breadcrumb>
                    {this.state.errorMessage && (
                        <DangerAlert name="dangerAlert">{this.state.errorMessage}</DangerAlert>
                    )}
                    <div className="button-group">
                        <Link to="/quotes/add" className="button__item">
                            <i className="icon-quotes-black"></i>Add Quote
                        </Link>
                    </div>
                    <div className="card card--datatables">
                        <div className="card-block">
                            <h2 className="card__title">Quotes</h2>
                            <div className="datatable-wrapper">
                                <div className="datatable-actions">
                                    <div className="btn btn--bulk">
                                        <a
                                            data-toggle="dropdown"
                                            href="#"
                                            role="button"
                                            aria-haspopup="true"
                                            aria-expanded="false"
                                        >
                                            Bulk Action <i className="icon-cheveron-down-black"></i>
                                        </a>
                                        <div className="dropdown-menu dropdown-menu-left">
                                            <a className="dropdown-item"
                                                href="#"
                                                onClick={(event) =>
                                                    this.awardQuotes(
                                                        event
                                                    )
                                                }>
                                                Mark as Awarded
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <DataTable
                                    ajaxUrl={this.baseUrl + "api/quotes/summary"}
                                    useAuth={true}
                                    ajaxData={this.dataTableData}
                                    ajaxDataFilter={this.dataTableDataFilter}
                                    onDraw={this.handleDataTableDraw}
                                    ref={this.dataTableComponentRef}
                                    searchPlaceholder="Project Name or Quote ID"
                                    stateSave={true}
                                >
                                    <thead>
                                        <tr>
                                            <th className="arrow-hidden" style={{ width: "1%" }}></th>
                                            <th style={{ width: "15%" }}>Status</th>
                                            <th style={{ width: "14%" }}>ID</th>
                                            <th style={{ width: "14%" }}>Quote Date</th>
                                            <th style={{ width: "29%" }}>Quote Name</th>
                                            <th style={{ width: "14%" }}>City</th>
                                            <th style={{ width: "14%" }}>Salesperson</th>
                                            <th className="arrow-hidden" style={{ width: "1%" }}></th>
                                        </tr>
                                    </thead>
                                    <tbody></tbody>
                                </DataTable>
                                {this.state.spinner ? (
                                    <ContentLoading />
                                ) : (
                                    <table className="d-none" ref={this.dataTableRef}>
                                        <tbody>
                                            {this.state.data.map((item, index) => {
                                                let quoteId = item.id.toString();
                                                let statusId = item.statusId || 0;
                                                if (item.isMaster) {
                                                    quoteId += "M";
                                                }
                                                if (item.revisionDate) {
                                                    quoteId +=
                                                        ", rev " + moment(item.revisionDate).format("l");
                                                }
                                                if (item.isDraft) {
                                                    quoteId += " (Draft)";
                                                }

                                                return (
                                                    <tr key={item.id}>
                                                        <td>
                                                            <input
                                                                name="check[]"
                                                                type="checkbox"
                                                                value={item.id}
                                                            />
                                                        </td>
                                                        <td>
                                                            <div className="status-dropdown">
                                                                <a
                                                                    data-toggle="dropdown"
                                                                    href="#"
                                                                    role="button"
                                                                    aria-haspopup="true"
                                                                    aria-expanded="false"
                                                                >
                                                                    <span>
                                                                        {this.quoteStatusNames[statusId]}
                                                                        <i className="icon-cheveron-down-black"></i>
                                                                    </span>
                                                                </a>
                                                                <div className="dropdown-menu dropdown-menu-left">
                                                                    {this.quoteStatusNames.map((item, index) => {
                                                                        if (index === 0 || index === statusId) {
                                                                            return;
                                                                        }

                                                                        return (
                                                                            <a
                                                                                className="dropdown-item"
                                                                                href="#"
                                                                                data-id={quoteId}
                                                                                data-status-id={index}
                                                                            >
                                                                                {item}
                                                                            </a>
                                                                        );
                                                                    })}
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>{quoteId}</td>
                                                        <td>
                                                            {item.quoteDate &&
                                                                moment(item.quoteDate).format("l")}
                                                        </td>
                                                        <td>
                                                            <Link to={"/quotes/" + item.id}>{item.name}</Link>
                                                        </td>
                                                        <td>{item.city}</td>
                                                        <td>{item.salesperson}</td>
                                                        <td>
                                                            <div style={{ display: "flex" }} >

                                                                <Link
                                                                    to={"/quotes/edit/" + item.id}
                                                                    className="btn-edit"
                                                                    title="Edit Quote"
                                                                >
                                                                    <i className="icon-edit1"></i>
                                                                </Link>

                                                                <Link to={"/quotes/" + item.id} title="View Quote">
                                                                    <svg
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        width="1em"
                                                                        height="1em"
                                                                        viewBox="0 0 48 48"
                                                                    >
                                                                        <g
                                                                            fill="none"
                                                                            stroke="currentColor"
                                                                            strokeLinejoin="round"
                                                                            strokeWidth="4"
                                                                        >
                                                                            <path d="M24 36c11.046 0 20-12 20-12s-8.954-12-20-12S4 24 4 24s8.954 12 20 12z"></path>
                                                                            <path d="M24 29a5 5 0 100-10 5 5 0 000 10z"></path>
                                                                        </g>
                                                                    </svg>
                                                                </Link>
                                                                {item.canCreateSalesOrder &&
                                                                    <Link
                                                                        to={"/quotes/salesorder/" + item.id}
                                                                        className="btn-salesorder"
                                                                        title="Create Sales Order"
                                                                    >
                                                                        <svg
                                                                            className="svg-icon"
                                                                            style={{
                                                                                width: '1.25em',
                                                                                height: '1.25em',
                                                                            }}
                                                                            viewBox="0 0 1024 1024"
                                                                            version="1.1"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                        >
                                                                            <path d="M768 192 256 192C217.6 192 192 217.6 192 256l0 576c0 38.4 25.6 64 64 64l512 0c38.4 0 64-25.6 64-64L832 256C832 217.6 806.4 192 768 192zM800 819.2c0 25.6-19.2 51.2-51.2 51.2L268.8 870.4c-25.6 0-51.2-19.2-51.2-51.2L217.6 268.8c0-25.6 19.2-51.2 51.2-51.2l480 0c25.6 0 51.2 19.2 51.2 51.2L800 819.2z" />
                                                                            <path d="M704 192 320 192l0 0c0-38.4 25.6-64 64-64l256 0C678.4 128 704 153.6 704 192L704 192z" />
                                                                            <path d="M320 313.6m-12.8 0a0.2 0.2 0 1 0 25.6 0 0.2 0.2 0 1 0-25.6 0Z" />
                                                                            <path d="M723.2 332.8 428.8 332.8c-6.4 0-12.8-6.4-12.8-12.8l0 0c0-6.4 6.4-12.8 12.8-12.8l288 0c6.4 0 12.8 6.4 12.8 12.8l0 0C736 326.4 729.6 332.8 723.2 332.8z" />
                                                                            <path d="M320 409.6m-12.8 0a0.2 0.2 0 1 0 25.6 0 0.2 0.2 0 1 0-25.6 0Z" />
                                                                            <path d="M723.2 428.8 428.8 428.8c-6.4 0-12.8-6.4-12.8-12.8l0 0c0-6.4 6.4-12.8 12.8-12.8l288 0c6.4 0 12.8 6.4 12.8 12.8l0 0C736 422.4 729.6 428.8 723.2 428.8z" />
                                                                            <path d="M640 582.4C633.6 576 627.2 576 620.8 582.4L512 684.8l-38.4-38.4c0 0 0 0 0 0-6.4-6.4-6.4-6.4-12.8-6.4-6.4 0-6.4 0-12.8 6.4 0 0 0 0 0 0l-44.8 44.8c-6.4 6.4-6.4 19.2 0 25.6 6.4 6.4 19.2 6.4 25.6 0l38.4-38.4 38.4 38.4c0 0 0 0 0 0 6.4 6.4 6.4 6.4 12.8 6.4 6.4 0 6.4 0 12.8-6.4 0 0 0 0 0 0L640 601.6C646.4 595.2 646.4 588.8 640 582.4z" />
                                                                            <path d="M723.2 780.8l-384 0L339.2 512c0-6.4-6.4-12.8-12.8-12.8S307.2 505.6 307.2 512l0 281.6c0 6.4 6.4 12.8 12.8 12.8l403.2 0c6.4 0 12.8-6.4 12.8-12.8S729.6 780.8 723.2 780.8z" />
                                                                        </svg>
                                                                    </Link>
                                                                }
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    public componentDidMount() {
        document.title = "Quotes - " + SITE_NAME;
    }

    private dataTableData(data: any) {

        let sortFields = [
            "",
            "quoteStatusName",
            "id",
            "date",
            "jobName",
            "jobCity",
            "firstName",
            ""
        ];

        let newData = {
            pageNumber: Math.floor(data.start / data.length) + 1,
            pageSize: data.length,
            sortField: sortFields[data.order[0].column],
            sortDirection: data.order[0].dir === "asc" ? 1 : 2,
            search: data.search.value,
            draw: data.draw,
        };

        return newData;
    }

    private dataTableDataFilter(data: string) {
        var json = JSON.parse(data) as DataTableApiResponse<QuoteSummary>;

        this.setState({
            data: json.items,
            spinner: false,
        });

        let tableData = [];
        let $tr = $(this.dataTableRef.current!).find("tr");
        for (let i = 0; i < $tr.length; i++) {
            let $td = $tr.eq(i).find("td");
            let rowData = [];
            for (let j = 0; j < $td.length; j++) {
                rowData.push($td.eq(j).clone(true, true).html());
            }
            tableData.push(rowData);
        }

        let newData = {
            draw: json.draw,
            recordTotal: json.metadata.totalItemCount,
            recordsFiltered: json.metadata.totalItemCount,
            data: tableData,
        };

        return JSON.stringify(newData);
    }

    private async awardQuotes(e: any) {
        e.preventDefault();
        this.setState({ errorMessage: undefined });

        var values = Array.prototype.map.call(
            document.querySelectorAll("input[name='check[]']:checked"),
            (e: HTMLInputElement) => parseInt(e.value)
        );
        var response = await apifetch(
            "quotes/award",
            {
                method: "POST",
                headers: new Headers({
                    Accept: "application/json",
                    "Content-Type": "application/json",
                }),
                body: JSON.stringify({ ids: values }),
            },
            true
        );
        if (response.ok) {
            this.dataTableComponentRef.current!.reload();
        } else {
            const errorText = await extractErrorMessage(response);
            this.setState({ errorMessage: errorText });
        }
    }

    private async setStatus(id: number, status: number) {
        this.setState({ errorMessage: undefined });
        let response = await apifetch(
            "quotes/" + id + "/setstatus",
            {
                method: "POST",
                headers: new Headers({
                    Accept: "application/json",
                    "Content-Type": "application/json",
                }),
                body: JSON.stringify({ status: status }),
            },
            true
        );
        if (response.ok) {
            this.dataTableComponentRef.current!.reload();
        } else {
            const errorText = await extractErrorMessage(response);
            this.setState({ errorMessage: errorText });
        }
    }

    private handleDataTableDraw(dataTable: any) {

        $(dataTable)
            .find("a:not([href='#'])")
            .click((e) => {
                e.preventDefault();
                this.props.history.push($(e.currentTarget).attr("href")!);
            });

        $(dataTable)
            .find(".status-dropdown .dropdown-item")
            .click((e) => {
                e.preventDefault();
                this.setStatus(
                    parseInt($(e.currentTarget).attr("data-id")!, 10),
                    parseInt($(e.currentTarget).attr("data-status-id")!, 10)
                );
            });

        $(dataTable).closest('.container').find('li.paginate_button').on('click', () => {
            this.setState({ spinner: true });
        });
        $(dataTable).closest('.container').find('th.sorting, th.sorting_asc, th.sorting-desc').on('click', () => {
            this.setState({ spinner: true });
        });

        this.setState({ spinner: false });
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/quotes/Index.tsx